// The "Differs in" value (and TranslationFallbackDiff's missingInDb check)
// for a row whose database has no en-GB text at all yet — distinct from a
// real text mismatch, since there is nothing to diff against.
export const FALLBACK_MISSING_IN_DB = "No en-GB in DB"
